var cov_dis1cj1sw = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Divider/index.tsx",
      hash = "c0fd6ce47301f4e2302ca2d64ce0076881f2669d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Divider/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 31
        },
        end: {
          line: 12,
          column: 41
        }
      },
      "1": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 44
        }
      },
      "2": {
        start: {
          line: 17,
          column: 69
        },
        end: {
          line: 17,
          column: 79
        }
      },
      "3": {
        start: {
          line: 18,
          column: 15
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "4": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 26,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 13
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 11
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 19
          }
        }, {
          start: {
            line: 13,
            column: 23
          },
          end: {
            line: 13,
            column: 44
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 30
          },
          end: {
            line: 19,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 30
          },
          end: {
            line: 19,
            column: 38
          }
        }, {
          start: {
            line: 19,
            column: 42
          },
          end: {
            line: 19,
            column: 53
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 55
          },
          end: {
            line: 19,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 55
          },
          end: {
            line: 19,
            column: 66
          }
        }, {
          start: {
            line: 19,
            column: 70
          },
          end: {
            line: 19,
            column: 96
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 24,
            column: 9
          },
          end: {
            line: 24,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 9
          },
          end: {
            line: 24,
            column: 24
          }
        }, {
          start: {
            line: 24,
            column: 28
          },
          end: {
            line: 24,
            column: 90
          }
        }],
        line: 24
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Divider/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { dividerClass } from './styles';

var Divider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Divider, _PureComponent);

  var _super = _createSuper2(Divider);

  function Divider() {
    _classCallCheck(this, Divider);

    return _super.apply(this, arguments);
  }

  _createClass(Divider, [{
    key: "showText",
    value: function showText() {
      cov_dis1cj1sw.f[0]++;

      var _ref = (cov_dis1cj1sw.s[0]++, this.props),
          children = _ref.children,
          mode = _ref.mode;

      cov_dis1cj1sw.s[1]++;
      return (cov_dis1cj1sw.b[0][0]++, children) && (cov_dis1cj1sw.b[0][1]++, mode === 'horizontal');
    }
  }, {
    key: "render",
    value: function render() {
      cov_dis1cj1sw.f[1]++;

      var _ref2 = (cov_dis1cj1sw.s[2]++, this.props),
          className = _ref2.className,
          children = _ref2.children,
          mode = _ref2.mode,
          orientation = _ref2.orientation,
          restProps = _objectWithoutProperties(_ref2, ["className", "children", "mode", "orientation"]);

      var mc = (cov_dis1cj1sw.s[3]++, classnames(dividerClass('_', mode, (cov_dis1cj1sw.b[1][0]++, children) && (cov_dis1cj1sw.b[1][1]++, 'with-text'), (cov_dis1cj1sw.b[2][0]++, orientation) && (cov_dis1cj1sw.b[2][1]++, "with-text-".concat(orientation))), className));
      cov_dis1cj1sw.s[4]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, restProps, {
          className: mc,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23,
            columnNumber: 7
          }
        }), (cov_dis1cj1sw.b[3][0]++, this.showText()) && (cov_dis1cj1sw.b[3][1]++,
        /*#__PURE__*/
        React.createElement("span", {
          className: dividerClass('inner-text'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 29
          }
        }, children)))
      );
    }
  }]);

  return Divider;
}(PureComponent);

Divider.defaultProps = {
  mode: 'horizontal'
};
export default Divider;